export enum Errors {
    InternalError,
    NotFound,
    IncorrectCurrentPassword,
}
